import myUtils from '../myUtils';
import apiConfig from './apiConfig';

const apiUrl = apiConfig.configApiUrl;
const options = (method, body) => apiConfig.configOptions(method, body);
const callApi = (_url, _options) => apiConfig.configCallApi(_url, _options);
//const callApi = (_url, _options, _callback) => apiConfig.configCallApi(_url, _options, _callback)

//=================== Property API =============================//
const getMaintenanceRequests = async ({
    page = 0,
    pageSize = 100000,
    status,
    statusArray,
    keyWord,
    locationType,
    maintenanceTypeId,
    technicianId,
    createByStaffId,
    problemNo,
    sendType,
    isStaffCreate,
    startDate,
    endDate,
    isReportQuery,
}) => {
    //MaintenanceRequest // page start at 0
    let propertyId = myUtils.getUser().propertyId;
    let paging = `,"limit":${pageSize > 0 ? pageSize : 100},"offset":${page * pageSize},"order":"createdAt DESC"`;
    let filterKeyWord = '';
    if (keyWord && keyWord != '') {
        filterKeyWord = `,"or":[{"no":{"like":"${keyWord}"}},{"name":{"like":"${keyWord}"}},{"homeNumber":{"like":"${keyWord}"}},{"area":{"like":"${keyWord}"}},{"description":{"like":"${keyWord}"}}]`;
    }
    let filterStatus = '';
    if (status && status != '') {
        filterStatus = `,"status":"${status}"`;
    } else if (statusArray && statusArray.length > 0) {
        filterStatus = `,"status":{"inq":${JSON.stringify(statusArray)}}`;
    }
    let filterLocationType = '';
    if (locationType && locationType != '' && locationType != 'all') {
        filterLocationType = `,"locationType":"${locationType}"`;
    }
    let filterMaintenanceTypeId = '';
    if (maintenanceTypeId && maintenanceTypeId != '') {
        filterMaintenanceTypeId = `,"maintenanceTypeId":"${maintenanceTypeId}"`;
    }
    let filterTechnicianId = '';
    if (technicianId && technicianId != '') {
        filterTechnicianId = `,"technicianId":"${technicianId}"`;
    }
    let filterCreateByStaffId = '';
    if (createByStaffId && createByStaffId != '') {
        filterCreateByStaffId = `,"createByStaffId":"${createByStaffId}"`;
    }
    let filterProblemNo = '';
    if (problemNo && problemNo != '') {
        filterProblemNo = `,"no":${problemNo}`;
    }
    let filterSendType = '';
    if (sendType && sendType != '') {
        filterSendType = `,"sendType":"${sendType}"`;
    }
    let filterIsStaffCreate = '';
    if (isStaffCreate && isStaffCreate != '') {
        filterSendType = `,"isStaffCreate":${isStaffCreate}`;
    }
    let filterStartDate = '';
    if (startDate && startDate != '') {
        filterStartDate = `,"createdAt":{"gt":"${startDate}"}`;
    }
    let filterEndDate = '';
    if (endDate && endDate != '') {
        filterEndDate = `,"createdAt":{"lt":"${endDate}"}`;
    }
    let url = `${apiUrl}/maintenance-requests?filter={"where":{"active":true,"propertyId":"${propertyId}"${filterStatus}${filterProblemNo}${filterLocationType}${filterTechnicianId}${filterCreateByStaffId}${filterMaintenanceTypeId}${filterLocationType}${filterSendType}${filterKeyWord}${filterIsStaffCreate}${filterStartDate}${filterEndDate}},"include":[{"relation":"maintenanceType"},{"relation":"user"},{"relation":"createByStaff"},{"relation":"updateByStaff"},{"relation":"home"},{"relation":"rating"},{"relation":"technician"},{"relation":"maintenancePartner"}] ${paging} }`;
    if (isReportQuery) {
        url = `${apiUrl}/maintenance-requests?filter={"where":{"active":true,"propertyId":"${propertyId}"${filterStatus}${filterProblemNo}${filterLocationType}${filterTechnicianId}${filterCreateByStaffId}${filterMaintenanceTypeId}${filterLocationType}${filterSendType}${filterKeyWord}${filterIsStaffCreate}${filterStartDate}${filterEndDate}},"include":[{"relation":"technician"}, {"relation":"rating"}] ${paging} }`;
    }
    const resp = await callApi(url, options('GET'));

    return resp;
};

const getMaintenanceRequestDetail = async (maintenanceRequestId) => {
    const url =
        apiUrl +
        `/maintenance-requests/${maintenanceRequestId}?filter={"include":[{"relation":"home"},{"relation":"maintenanceType"},{"relation":"user"},{"relation":"staff"},{"relation":"acceptStaff"},{"relation":"completeStaff"},{"relation":"createByStaff"},{"relation":"updateByStaff"},{"relation":"home"},{"relation":"maintenanceImages"},{"relation":"maintenancePartner"},{"relation":"maintenanceResultImages"},{"relation":"technician"},{"relation":"rating"}]}`;
    const resp = await callApi(url, options('GET'));
    return resp;
};

const getMaintenanceRequestDetailByNoNumber = async (no) => {
    let propertyId = myUtils.getUser().propertyId;
    const url =
        apiUrl +
        `/maintenance-requests?filter={"where":{"no":"${no}","propertyId":"${propertyId}"},"include":[{"relation":"home"},{"relation":"maintenanceType"},{"relation":"user"},{"relation":"staff"},{"relation":"acceptStaff"},{"relation":"completeStaff"},{"relation":"createByStaff"},{"relation":"home"},{"relation":"maintenanceImages"},{"relation":"maintenancePartner"},{"relation":"maintenanceResultImages"},{"relation":"technician"}]}`;
    const resp = await callApi(url, options('GET'));
    const { status, response } = resp;

    return { status: status, response: response && response.length > 0 ? response[0] : null };
};

const createMaintenanceRequest = async (body) => {
    const url = apiUrl + `/maintenance-requests`;
    const resp = await callApi(url, options('POST', body));
    return resp;
};

const patchMaintenanceRequest = async (maintenanceRequestId, body) => {
    const url = apiUrl + `/maintenance-requests/${maintenanceRequestId}`;
    const resp = await callApi(url, options('PATCH', body));
    return resp;
};

const deleteMaintenanceRequest = async (maintenanceRequestId) => {
    const url = apiUrl + `/maintenance-requests/${maintenanceRequestId}`;
    var res = await callApi(url, options('PATCH', { active: false }));
    return res;
};

const createMaintenanceImage = async (body) => {
    const url = apiUrl + `/maintenance-images`;
    const resp = await callApi(url, options('POST', body));
    return resp;
};

const deleteMaintenanceImage = async (maintenanceImageId) => {
    const url = apiUrl + `/maintenance-images/${maintenanceImageId}`;
    var resp = await callApi(url, options('PATCH', { active: false }));

    return resp;
};

const createMaintenanceResultImage = async (body) => {
    const url = apiUrl + `/maintenance-result-image`;
    const resp = await callApi(url, options('POST', body));
    return resp;
};

const deleteMaintenanceResultImage = async (maintenanceImageId) => {
    const url = apiUrl + `/maintenance-result-image/${maintenanceImageId}`;
    var resp = await callApi(url, options('PATCH', { active: false }));

    return resp;
};

const countMaintenance = async ({
    status,
    statusArray,
    keyWord,
    locationType,
    maintenanceTypeId,
    technicianId,
    createByStaffId,
    startDate,
    endDate,
    sendType,
    isStaffCreate,
}) => {
    let propertyId = myUtils.getUser().propertyId;
    let filterKeyWord = '';
    if (keyWord && keyWord != '') {
        filterKeyWord = `,"or":[{"homeNumber":{"like":"${keyWord}"}},{"name":{"like":"${keyWord}"}},{"area":{"like":"${keyWord}"}},{"description":{"like":"${keyWord}"}}]`;
    }
    let filterStatus = '';
    if (status && status != '') {
        filterStatus = `,"status":"${status}"`;
    } else if (statusArray && statusArray.length > 0) {
        filterStatus = `,"status":{"inq":${JSON.stringify(statusArray)}}`;
    }
    let filterLocationType = '';
    if (locationType && locationType != '' && locationType != 'all') {
        filterLocationType = `,"locationType":"${locationType}"`;
    }
    let filterMaintenanceTypeId = '';
    if (maintenanceTypeId && maintenanceTypeId != '') {
        filterMaintenanceTypeId = `,"maintenanceTypeId":"${maintenanceTypeId}"`;
    }
    let filterTechnicianId = '';
    if (technicianId && technicianId != '') {
        filterTechnicianId = `,"technicianId":"${technicianId}"`;
    }
    let filterCreateByStaffId = '';
    if (createByStaffId && createByStaffId != '') {
        filterCreateByStaffId = `,"createByStaffId":"${createByStaffId}"`;
    }
    let filterStartDate = '';
    if (startDate && startDate != '') {
        filterStartDate = `,"createdAt":{"gt":"${startDate}"}`;
    }
    let filterEndDate = '';
    if (endDate && endDate != '') {
        filterEndDate = `,"createdAt":{"lt":"${endDate}"}`;
    }
    let filterSendType = '';
    if (sendType && sendType != '') {
        filterSendType = `,"sendType":"${sendType}"`;
    }
    let filterIsStaffCreate = '';
    if (isStaffCreate && isStaffCreate != '') {
        filterSendType = `,"isStaffCreate":${isStaffCreate}`;
    }
    const countUrl = `${apiUrl}/maintenance-requests/count?where={"active":true,"propertyId":"${propertyId}"${filterStatus}${filterLocationType}${filterTechnicianId}${filterCreateByStaffId}${filterMaintenanceTypeId}${filterLocationType}${filterKeyWord}${filterStartDate}${filterEndDate}${filterSendType}${filterIsStaffCreate}}`;
    var resp = await callApi(countUrl, options('GET'));

    return resp;
};

const countMaintenanceByCompany = async ({ companyId }) => {
    let filterCompanyId = '';
    if (companyId && companyId != '') {
        filterCompanyId = `,"companyId":"${companyId}"`;
    }
    const countUrl = `${apiUrl}/maintenance-requests/count?where={"active":true${filterCompanyId}}`;
    var resp = await callApi(countUrl, options('GET'));

    return resp;
};

const getMaintenacenTypes = async ({ locationType, isEnable }) => {
    //Home // page start at 0
    let propertyId = myUtils.getUser().propertyId;
    let paging = `,"order":"createdAt ASC"`;
    let filterLocationType = '';
    if (locationType && locationType != '') {
        filterLocationType = `,"locationType":"${locationType}"`;
    }
    let filterIsEnable = '';
    if (isEnable) {
        filterIsEnable = `,"isEnable":${isEnable}`;
    }
    const url =
        apiUrl +
        `/maintenance-types?filter={"where":{"active":true,"propertyId":"${propertyId}"${filterLocationType}${filterIsEnable}} ${paging} }`;
    var resp = await callApi(url, options('GET'));

    return resp;
};

const getMaintenacenTypeDetail = async (maintenacenTypeId) => {
    const url = apiUrl + `/maintenance-types/${maintenacenTypeId}`;
    const resp = await callApi(url, options('GET'));
    return resp;
};

const createMaintenanceType = async (body) => {
    const url = apiUrl + `/maintenance-types`;
    const resp = await callApi(url, options('POST', body));
    return resp;
};

const patchMaintenanceType = async (maintenanceTypeId, body) => {
    const url = apiUrl + `/maintenance-types/${maintenanceTypeId}`;
    const resp = await callApi(url, options('PATCH', body));
    return resp;
};

const deleteMaintenanceType = async (maintenanceTypeId) => {
    const url = apiUrl + `/maintenance-types/${maintenanceTypeId}`;
    var resp = await callApi(url, options('PATCH', { active: false }));

    return resp;
};

const getMaintenanceNextReferenceNo = async () => {
    let propertyId = myUtils.getUser().propertyId;
    let paging = `,"limit":1,"order":"createdAt DESC"`;
    const url = `${apiUrl}/maintenance-requests?filter={"where":{"propertyId":"${propertyId}"}${paging} }`;
    const resp = await callApi(url, options('GET'));
    const { status, response } = resp;

    if (status && response && response.length > 0) {
        let nextNumber = 100000;
        if (
            response?.[0]?.no &&
            response?.[0]?.no !== '' &&
            response?.[0]?.no !== 'NaN' &&
            response?.[0]?.no !== 'undefined'
        ) {
            nextNumber = response?.[0]?.no + 1;
        }
        return nextNumber;
    } else {
        return 100000; //default
    }
};

export default {
    //MAINTENANCE REQUEST API
    getMaintenanceRequests,
    getMaintenanceRequestDetail,
    getMaintenanceRequestDetailByNoNumber,
    createMaintenanceRequest,
    patchMaintenanceRequest,
    deleteMaintenanceRequest,
    createMaintenanceImage,
    deleteMaintenanceImage,
    createMaintenanceResultImage,
    deleteMaintenanceResultImage,
    countMaintenance,
    countMaintenanceByCompany,
    getMaintenacenTypes,
    getMaintenacenTypeDetail,
    createMaintenanceType,
    patchMaintenanceType,
    deleteMaintenanceType,
    getMaintenanceNextReferenceNo,
};
